import { RepositoryCompany } from './../models/RepositoryCompany';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigServiceService } from './app-config-service.service';
import { BehaviorSubject } from 'rxjs';
import { HelpersService } from './shared/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class RepositoryService {

  public serverParametersSource = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('serverParameters')));
  public currentServerParameters = this.serverParametersSource.asObservable();

  public repositoryCompanySource = new BehaviorSubject<{code, id, nameSmall}>(JSON.parse(sessionStorage.getItem('selectedCompany')));
  public currentRepositoryCompany = this.repositoryCompanySource.asObservable();

  public luminaPOSFilterToggleSource = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('luminaPOSfilter')));
  public currentluminaPOSFilterToggle = this.luminaPOSFilterToggleSource.asObservable();

  public curHostname;
  constructor(private http: HttpClient, private appConfigService: AppConfigServiceService, private helpersService: HelpersService) {
    this.helpersService.currentHostname.subscribe( data => {
      this.curHostname = data;
    });
  }

  changeServerParameters(newServerParameter: string) {
    localStorage.setItem('serverParameters', JSON.stringify(newServerParameter));
    this.serverParametersSource.next(newServerParameter);
  }

  changeRepositoryCompany(newCompaany: {code, id, nameSmall}) {
    sessionStorage.setItem('selectedCompany', JSON.stringify(newCompaany));
    this.repositoryCompanySource.next(newCompaany);
  }

  changeLuminaPOSFilter(toggle) {
    localStorage.setItem('luminaPOSfilter', JSON.stringify(toggle));
    this.luminaPOSFilterToggleSource.next(toggle);
  }
  getCompanies() {
    return this.http.post<any>(this.curHostname + this.appConfigService.api + "repository/getCompanies", null);
  }

  getLicenses(modul, serverCode, modulId, companyId) {
    let params = new HttpParams();
    params = params.append('modul', modul);
    params = params.append('serverCode', serverCode);
    params = params.append('modulId', modulId);
    params = params.append('companyId', companyId);
    
    return this.http.post<any>(this.curHostname + this.appConfigService.api + "repository/getLicences", params);
  }

  getServers(modulId, companyId) {
    let params = new HttpParams();
    params = params.append('modulId', modulId);
    params = params.append('companyId', companyId);
    return this.http.post<any>(this.curHostname + this.appConfigService.api + 'repository/getServers', params);
  }

}
